import {
    DateField,
    Datagrid,
    DeleteButton,
    Edit,
    EditButton,
    List,
    required,
    Show,
    ShowButton,
    SimpleForm,
    SimpleShowLayout,
    TextField,
    TextInput,
} from 'react-admin';

import { ADMIN_CONTACT_US_RESOURCE } from '../admin/adminContactUsDataProvider';
import { StatusChipField } from '../admin/StatusChipField';

const contactUsListFilters = [
    <TextInput key="search" source="search" label="Search" alwaysOn />,
    <TextInput key="status" source="status" label="Status" alwaysOn />,
];

export const ContactUsList = () => (
    <List filters={contactUsListFilters} perPage={10} sort={{ field: 'contactRequestId', order: 'DESC' }}>
        <Datagrid rowClick="show" bulkActionButtons={false}>
            <TextField source="contactRequestId" label="Contact Request Id" />
            <TextField source="subject" />
            <StatusChipField source="status" label="Status" />
            <TextField source="email" />
            <TextField source="mobile" />
            <DateField source="createdAt" showTime />
            <DateField source="updatedAt" showTime />
            <ShowButton />
            <EditButton />
            <DeleteButton />
        </Datagrid>
    </List>
);

export const ContactUsShow = () => (
    <Show>
        <SimpleShowLayout>
            <TextField source="contactRequestId" label="Contact Request Id" />
            <TextField source="subject" />
            <StatusChipField source="status" label="Status" />
            <TextField source="email" />
            <TextField source="mobile" />
            <TextField source="message" />
            <DateField source="createdAt" showTime />
            <DateField source="updatedAt" showTime />
        </SimpleShowLayout>
    </Show>
);

export const ContactUsEdit = () => (
    <Edit resource={ADMIN_CONTACT_US_RESOURCE}>
        <SimpleForm>
            <TextInput source="contactRequestId" label="Contact Request Id" disabled fullWidth />
            <TextInput source="subject" disabled fullWidth />
            <TextInput
                source="status"
                label="Status"
                validate={required()}
                helperText="Only status can be updated. Use exact values such as pending or done."
                fullWidth
            />
            <TextInput source="email" disabled fullWidth />
            <TextInput source="mobile" disabled fullWidth />
            <TextInput source="message" disabled multiline minRows={8} fullWidth />
            <TextInput source="createdAt" label="Created At" disabled fullWidth />
            <TextInput source="updatedAt" label="Updated At" disabled fullWidth />
        </SimpleForm>
    </Edit>
);